<template>
  <el-dialog class="customDialog addLayer" title="新建图层" :visible.sync="isShow" :close-on-click-modal="false" :close-on-press-escape = 'false' @close="onClose">
    <div class="formContainer">
      <el-form :model="formInline" :rules="rules" ref="form">
        <el-form-item label="图层类型：" prop="layerType" class="row">
          <el-radio-group class="form-short"  v-model="formInline.layerType" @change="onChangeLayerType">
            <el-radio v-for="(item, index) in markerTypeOptions" :key="index" :label="item.id">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图层名称：" prop="name" class="row">
          <el-input class="form-short" v-model.trim="formInline.name" placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="所属文件夹：" class="row">
          <!-- <el-select class="form-short" v-model="formInline.folderId" filterable disabled placeholder="请选择">
            <el-option v-for="item in folderOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <TreeSelect class="form-short" v-model="formInline.folderId" filterable clearable :options="folderTree" :props="folderProps" placeholder="请选择"></TreeSelect>
        </el-form-item>
        <el-form-item label="关联数据源：" prop="isLinkData" >
          <el-switch
            v-model="formInline.isLinkData"
            active-color="#00A4F0"
            inactive-color="rgba(255, 255, 255, 0.2)"
            @change="formInline.tableId = undefined"
          >
          </el-switch>
        </el-form-item>
        <div v-if="formInline.isLinkData===true">
          <el-divider></el-divider>
          <el-form-item label="数据源类型：" prop="dataSourceType" class="row">
            <el-select class="form-short"  v-model="formInline.dataSourceType" filterable  placeholder="请选择" @change="getTableList">
              <el-option v-for="item in dataSourceType" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据源：" prop="tableId" class="row">
            <el-select class="form-short"  v-model="formInline.tableId" filterable  placeholder="请选择">
              <el-option v-for="item in tableList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addLayer } from '@/api/marker'
import { getDataSourcesList } from '@/api/dataManagement'
import { mapGetters } from 'vuex'
import TreeSelect from '@/components/TreeSelect/TreeSelect'
export default {
  name: 'AddLayer',
  components: {
    TreeSelect
  },
  computed: {
    ...mapGetters(['folderTree'])
  },
  data () {
    return {
      isShow: false,
      formInline: {
        layerType: 'POINT',
        name: '',
        folderId: undefined,
        tableId: undefined,
        isLinkData: false,
        dataSourceType: 'EXCEL'
      },
      markerTypeOptions: [
        { id: 'POINT', title: '点' },
        { id: 'LINE', title: '线' },
        { id: 'PLANE', title: '面' }
      ],
      rules: {
        layerType: [
          { required: true, message: '请选择图层类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入图层名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ],
        dataSourceType: [
          { required: true, message: '请选择数据源类型', trigger: 'blur' }
        ],
        tableId: [
          { required: true, message: '请选择数据源', trigger: 'blur' }
        ]
        // folderId: [
        //   { required: true, message: '请选择所属文件夹', trigger: 'blur' }
        // ]
      },
      dataSourceType: [
        { value: 'EXCEL', name: 'EXCEL文件' },
        { value: 'API', name: 'API接口' }
      ],
      folderProps: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      // 表单列表
      tableList: [],
      loading: false
    }
  },
  mounted () {},
  methods: {
    open (id) {
      this.clear()
      this.isShow = true
      this.getTableList()
    },
    clear () {
      this.formInline = this.$options.data().formInline
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    onClose () {
      // this.clear()
      this.isShow = false
    },
    // 获取数据源数据
    async getTableList () {
      this.tableList = []
      this.formInline.tableId = undefined
      const res = await getDataSourcesList({
        dataSourceType: this.formInline.dataSourceType
      })
      if (res.code === 200) {
        res.data.forEach(item => {
          this.tableList.push({
            dataSourceType: item.dataSourceType,
            name: item.name,
            id: item.dataSourceType === 'EXCEL' ? item.excelData.id : item.id
          })
        })
      }
    },
    // 图层类型改变
    onChangeLayerType (type) {
      if (type === 'POINT') {
        this.dataSourceType = [
          { value: 'EXCEL', name: 'EXCEL文件' },
          { value: 'API', name: 'API接口' }
        ]
      } else {
        this.dataSourceType = [
          { value: 'EXCEL', name: 'EXCEL文件' }
        ]
      }
      this.formInline.dataSourceType = 'EXCEL'
      this.formInline.tableId = undefined
    },
    // 创建未绑定数据图层
    async createUnBindLayer () {
      try {
        this.loading = true
        const res = await addLayer({
          name: this.formInline.name,
          mapId: this.$route.query.mapId ? this.$route.query.mapId : 0,
          type: this.formInline.layerType,
          groupId: this.formInline.folderId,
          tableId: this.formInline.tableId
        })
        if (res.code === 200) {
          this.$Message('success', '创建图层成功')
          this.$emit('refresh')
          this.onClose()
          if (!this.formInline.isLinkData) {
            const curLayerId = res.data
            await this.$Submit({
              message: '您未关联表单，是否为图层创建属性列表？',
              confirmButtonText: '编辑属性列表',
              cancelButtonText: '稍后再说'
            })
            this.$emit('showAttribute', curLayerId)
          }
        }
      } finally {
        this.loading = false
      }
    },
    // 创建绑定数据图层
    createBindLayer () {
      this.$emit('createBindTableLayer', {
        name: this.formInline.name,
        mapId: this.$route.query.mapId ? this.$route.query.mapId : 0,
        type: this.formInline.layerType,
        groupId: this.formInline.folderId,
        tableId: this.formInline.tableId,
        dataSourceId: this.formInline.tableId,
        dataSourceType: this.formInline.dataSourceType
      })
    },
    async onSubmit () {
      await this.$refs.form.validate()
      if (this.formInline.isLinkData) {
        this.createBindLayer()
      } else {
        this.createUnBindLayer()
      }
    }
  }
}
</script>

<style lang="scss">
.addLayer {
  .el-dialog{
    width: 460px;
    .el-form-item__content {
      width: unset !important;
    }
    .el-form-item__label{
      width: 140px;
    }
    .el-form-item__error{
      left: 120px;
    }
  }
  .el-divider{
    background-color: rgba(#FFFFFF, 0.1) !important;
    margin-top: 0px;
  }
  .el-dialog__body{
    .el-form-item__label{
      padding-right: 0
    }
  }
}
</style>
<style lang="scss" scoped>
.addLayer {
  .form-short {
    width: 260px !important;
  }
}
</style>
